import React, { useState } from 'react';
import { ArrowRightIcon, PlusIcon, EditIcon, TrashIcon, CheckIcon } from 'lucide-react';
export function IntegrationsFieldMappingTab() {
  const [selectedConnection, setSelectedConnection] = useState('salesforce');
  const connections = [{
    id: 'salesforce',
    name: 'Salesforce Production'
  }, {
    id: 'hubspot',
    name: 'HubSpot'
  }, {
    id: 'marketo',
    name: 'Marketo'
  }];
  const fieldMappings = [{
    id: 1,
    sourceField: 'Account.Name',
    targetField: 'company_name',
    type: 'String',
    transformation: 'None',
    required: true,
    status: 'active'
  }, {
    id: 2,
    sourceField: 'Account.Industry',
    targetField: 'industry',
    type: 'Picklist',
    transformation: 'Map to taxonomy',
    required: true,
    status: 'active'
  }, {
    id: 3,
    sourceField: 'Account.AnnualRevenue',
    targetField: 'revenue',
    type: 'Currency',
    transformation: 'Format currency',
    required: false,
    status: 'active'
  }, {
    id: 4,
    sourceField: 'Contact.Email',
    targetField: 'email',
    type: 'Email',
    transformation: 'Validate & normalize',
    required: true,
    status: 'active'
  }, {
    id: 5,
    sourceField: 'Contact.Phone',
    targetField: 'phone',
    type: 'Phone',
    transformation: 'Format E.164',
    required: false,
    status: 'active'
  }, {
    id: 6,
    sourceField: 'Opportunity.Amount',
    targetField: 'deal_value',
    type: 'Currency',
    transformation: 'Convert to USD',
    required: true,
    status: 'active'
  }, {
    id: 7,
    sourceField: 'Opportunity.StageName',
    targetField: 'stage',
    type: 'Picklist',
    transformation: 'Map to standard stages',
    required: true,
    status: 'active'
  }, {
    id: 8,
    sourceField: 'Lead.Status',
    targetField: 'lead_status',
    type: 'Picklist',
    transformation: 'None',
    required: false,
    status: 'warning'
  }];
  const unmappedFields = [{
    field: 'Account.Type',
    type: 'Picklist'
  }, {
    field: 'Contact.Title',
    type: 'String'
  }, {
    field: 'Opportunity.CloseDate',
    type: 'Date'
  }];
  return <div className="space-y-6" data-id="element-1666">
      {/* Connection Selector */}
      <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1667">
        <label className="block text-sm font-medium text-gray-900 mb-2" data-id="element-1668">
          Select Connection
        </label>
        <select value={selectedConnection} onChange={e => setSelectedConnection(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent" data-id="element-1669">
          {connections.map(conn => <option key={conn.id} value={conn.id} data-id="element-1670">
              {conn.name}
            </option>)}
        </select>
      </div>
      {/* Mapping Summary */}
      <div className="grid grid-cols-3 gap-4" data-id="element-1671">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1672">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1673">Total Mappings</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-1674">
            {fieldMappings.length}
          </p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1675">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1676">Active</p>
          <p className="text-3xl font-bold text-green-600" data-id="element-1677">
            {fieldMappings.filter(m => m.status === 'active').length}
          </p>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1678">
          <p className="text-sm text-gray-600 mb-1" data-id="element-1679">Unmapped Fields</p>
          <p className="text-3xl font-bold text-yellow-600" data-id="element-1680">
            {unmappedFields.length}
          </p>
        </div>
      </div>
      {/* Field Mappings Table */}
      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-1681">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1682">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1683">
            Field Mappings
          </h3>
          <button className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium" data-id="element-1684">
            <PlusIcon className="w-4 h-4" data-id="element-1685" />
            Add Mapping
          </button>
        </div>
        <table className="w-full" data-id="element-1686">
          <thead className="bg-gray-50 border-b border-gray-200" data-id="element-1687">
            <tr data-id="element-1688">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1689">
                Source Field
              </th>
              <th className="px-6 py-3 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1690"></th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1691">
                Target Field
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1692">
                Type
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1693">
                Transformation
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1694">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1695">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1696">
            {fieldMappings.map(mapping => <tr key={mapping.id} className="hover:bg-gray-50" data-id="element-1697">
                <td className="px-6 py-4" data-id="element-1698">
                  <div className="flex items-center gap-2" data-id="element-1699">
                    <span className="text-sm font-mono text-gray-900" data-id="element-1700">
                      {mapping.sourceField}
                    </span>
                    {mapping.required && <span className="text-red-600 text-xs" data-id="element-1701">*</span>}
                  </div>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-1702">
                  <ArrowRightIcon className="w-4 h-4 text-gray-400 mx-auto" data-id="element-1703" />
                </td>
                <td className="px-6 py-4" data-id="element-1704">
                  <span className="text-sm font-mono text-gray-900" data-id="element-1705">
                    {mapping.targetField}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1706">
                  <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium" data-id="element-1707">
                    {mapping.type}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1708">
                  <span className="text-sm text-gray-700" data-id="element-1709">
                    {mapping.transformation}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1710">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${mapping.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`} data-id="element-1711">
                    {mapping.status}
                  </span>
                </td>
                <td className="px-6 py-4" data-id="element-1712">
                  <div className="flex items-center gap-2" data-id="element-1713">
                    <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" title="Edit" data-id="element-1714">
                      <EditIcon className="w-4 h-4 text-gray-600" data-id="element-1715" />
                    </button>
                    <button className="p-1.5 hover:bg-gray-100 rounded transition-colors" title="Delete" data-id="element-1716">
                      <TrashIcon className="w-4 h-4 text-red-600" data-id="element-1717" />
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Unmapped Fields */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-1718">
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-1719">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-1720">
            Unmapped Source Fields
          </h3>
          <p className="text-sm text-gray-600 mt-1" data-id="element-1721">
            These fields are available but not currently mapped
          </p>
        </div>
        <div className="p-6" data-id="element-1722">
          <div className="space-y-2" data-id="element-1723">
            {unmappedFields.map((field, index) => <div key={index} className="flex items-center justify-between p-3 bg-yellow-50 rounded-lg border border-yellow-200" data-id="element-1724">
                <div className="flex items-center gap-3" data-id="element-1725">
                  <span className="text-sm font-mono text-gray-900" data-id="element-1726">
                    {field.field}
                  </span>
                  <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium" data-id="element-1727">
                    {field.type}
                  </span>
                </div>
                <button className="flex items-center gap-2 px-3 py-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium" data-id="element-1728">
                  <PlusIcon className="w-4 h-4" data-id="element-1729" />
                  Map Field
                </button>
              </div>)}
          </div>
        </div>
      </div>
      {/* Validation Rules */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1730">
        <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1731">
          Validation Rules
        </h3>
        <div className="space-y-3" data-id="element-1732">
          <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg border border-green-200" data-id="element-1733">
            <CheckIcon className="w-5 h-5 text-green-600" data-id="element-1734" />
            <span className="text-sm text-gray-900" data-id="element-1735">
              All required fields are mapped
            </span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg border border-green-200" data-id="element-1736">
            <CheckIcon className="w-5 h-5 text-green-600" data-id="element-1737" />
            <span className="text-sm text-gray-900" data-id="element-1738">
              No duplicate target fields
            </span>
          </div>
          <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg border border-green-200" data-id="element-1739">
            <CheckIcon className="w-5 h-5 text-green-600" data-id="element-1740" />
            <span className="text-sm text-gray-900" data-id="element-1741">
              Data type compatibility verified
            </span>
          </div>
        </div>
      </div>
    </div>;
}